import svgPathBounds from "svg-path-bounds";
import { config } from "../config/config";
import { staticImages } from "../assets/icons/svg-icons";

export const computeViewBox = (paths) => {
  let minX = Infinity,
    minY = Infinity,
    maxX = -Infinity,
    maxY = -Infinity;

  paths.forEach((d) => {
    try {
      const [x1, y1, x2, y2] = svgPathBounds(d);
      minX = Math.min(minX, x1);
      minY = Math.min(minY, y1);
      maxX = Math.max(maxX, x2);
      maxY = Math.max(maxY, y2);
    } catch (error) {
      // console.error("Invalid SVG path:", d, error);
    }
  });

  if (
    minX === Infinity ||
    minY === Infinity ||
    maxX === -Infinity ||
    maxY === -Infinity
  ) {
    return "0 0 24 24"; // Default fallback
  }

  return `${minX} ${minY} ${maxX - minX} ${maxY - minY}`;
};

export const getImageURL = (path) => {


  if (path) {
   
    if (path.includes(config.apiBaseURL)) {
      return path;
    } else {
      return `${config.apiBaseURL}/${path}`;
    }
  } else {
    return `../${staticImages.profileImg}`;
  }
};

export const convertIntoPascalCase = (input) => {
  return input
    .split("_") // Split the string by underscores
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(" "); // Join the words with a space
};

export const getRolePath = (role) => role?.replace(/_/g, "-"); // Converts backend role (snake_case) to URL path (kebab-case)

/**
 * Format date to user-friendly format
 * @param {string|Date} dateInput - Date string or Date object
 * @param {string} format - Format type: 'long' (default), 'short', 'medium'
 * @returns {string} Formatted date string
 */
// export const formatDate = (dateInput, format = "long") => {
//   if (!dateInput) return "-";

//   const date = new Date(dateInput);

//   // Check if date is valid
//   if (isNaN(date.getTime())) return "-";

//   const formatOptions = {
//     long: {
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//     }, // "10 July, 2022"
//     short: (date) => {
//       return date
//         .toLocaleDateString("en-GB", {
//           day: "2-digit",
//           month: "2-digit",
//           year: "numeric",
//         })
//         .replace(/\//g, "-"); // 🔥 replace / with -
//     },
//     medium: {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//     }, // "10 Jul, 2022"
//   };

//   return date.toLocaleDateString(
//     "en-IN",
//     formatOptions[format] || formatOptions.long,
//   );
// };


export const formatDate = (dateInput, format = "long") => {
  if (!dateInput) return "-";

  const date = new Date(dateInput);

  if (isNaN(date.getTime())) return "-";

  // ✅ handle short separately
  if (format === "short") {
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");
  }

  const formatOptions = {
    long: {
      day: "numeric",
      month: "long",
      year: "numeric",
    },
    medium: {
      day: "numeric",
      month: "short",
      year: "numeric",
    },
  };

  return date.toLocaleDateString(
    "en-IN",
    formatOptions[format] || formatOptions.long
  );
};